import axios from 'axios';

export async function downloadLog(date) {
    // Match ASP.NET route api/Logs/{date}; relative URL preserves axios baseURL path (e.g. …/bioticapi/api).
    const response = await axios.get(`Logs/${date}`, { responseType: 'blob' });
    return response.data;
}

export async function downloadAppInsightsLog(date) {
    const response = await axios.get(`Logs/appinsights/${date}`, { responseType: 'blob' });
    return response.data;
}
